<template>
  <div>
    <div id="main-wrapper">
      <div
        class="position-relative overflow-hidden radial-gradient min-vh-100 w-100 d-flex align-items-center justify-content-center">
        <div class="d-flex align-items-center justify-content-center w-100">
          <div class="row justify-content-center w-100">
            <div class="col-md-8 col-lg-6 col-xxl-3">
              <div class="card mb-0 bg-body">
                <div class="card-body">
                  <span class="text-nowrap logo-img text-center d-block mb-5 w-100">
                    <img v-show="theme == 'light'" src="@/assets/images/logo_black.png" class="dark-logo mb-5"
                      alt="Logo-Dark" width="200" />
                    <img v-show="theme == 'dark'" src="@/assets/images/logo.png" class="dark-logo mb-5" alt="Logo-Dark"
                      width="200" />
                  </span>
                  <div>
                    <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label">E-mail</label>
                      <input type="email" class="form-control" v-model="email">
                    </div>
                    <div class="mb-4">
                      <label for="exampleInputPassword1" class="form-label">Senha</label>
                      <input type="password" class="form-control" v-model="password">
                    </div>
                    <div class="d-flex align-items-center justify-content-between mb-4">
                    </div>
                    <span @click="auth" class="btn btn-primary w-100 py-8 mb-4 rounded-2">Acessar</span>
                    <router-link to="/consultar"
                      class="btn btn-warning w-100 py-8 mt-2 rounded-2">Consultar</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {

  data() {
    return {
      email: '',
      password: '',
      theme: Cookies.get("theme") || "light"
    }
  },
  methods: {
    clear() {
      this.email = "";
      this.password = "";
    },
    showAlert(type, msg) {
      var textMsg = "";

      if (msg.message) {
        if (typeof msg.errors === 'object' && msg.errors) {
          for (const key in msg.errors) {
            if (Object.prototype.hasOwnProperty.call(msg.errors, key)) {
              const errorMessages = msg.errors[key];
              textMsg += `${errorMessages.join(', ')}<br>`;
            }
          }
        } else {
          textMsg = `${msg.message}`;
        }
      } else {
        textMsg = `${msg}`;
      }

      this.$swal({
        text: textMsg,
        icon: type,
        confirmButtonText: 'Confirmar',
        html: textMsg
      });
    },
    auth() {
      var json = {
        email: this.email,
        password: this.password,
      };

      this.$http
        .post("/login", json, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {

          Cookies.set('_token', response.data.user.token);

          this.$store.dispatch('setRoleOnLogin', response.data.user.individual.role_id);
          this.$store.dispatch('setUser', response.data.user);

          if (!Cookies.get('theme')) {
            Cookies.set('theme', 'light')
          }

          Cookies.set('code', response.data.user.code);
          Cookies.set('individual', JSON.stringify(response.data.user.individual));

          setTimeout(() => {
            this.$router.push('/home');
          }, 1000);

        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.showAlert('error', error.response.data);
          } else {
            this.showAlert('error', 'Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento.');
          }
        });
    }
  },
  created() {
    if (Cookies.get('_token')) {
      Cookies.remove('_token');
    }

    if (!Cookies.get('theme')) {
      Cookies.set('theme', 'light');
    }
  }
}
</script>
